module.exports = __webpack_public_path__ + "static/media/hamsa.34473dad.jpg";